import { render, staticRenderFns } from "./Upsell.vue?vue&type=template&id=76b0e54a"
import script from "./Upsell.vue?vue&type=script&lang=ts"
export * from "./Upsell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports